import React from 'react';
import Box from '@mui/material/Box';
import { ReactComponent as Logo } from '../assets/svg/logo.svg';
import { reusableStyles } from '../ui-blocks/ReusableStyles';
import { colorPalette } from '../ui-blocks/ColorPalette';

function LoadingScreen() {
	return (
		<Box sx={[reusableStyles.fixedScreen, reusableStyles.flexCol, { gap: '32px' }]}>
			<Logo style={{ color: colorPalette.light4 }} />
		</Box>
	);
}

export default LoadingScreen;
